import { useState } from 'react';
import { api, errorText } from '../lib/api';

export function Login({ setup, onDone }: { setup: boolean; onDone: () => void }) {
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr('');
    try {
      await api(setup ? '/api/auth/setup' : '/api/auth/login', { body: setup ? { code, password } : { password } });
      onDone();
    } catch (e2) {
      setErr(errorText(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="login">
      <form className="card login-card" onSubmit={submit}>
        <h1>TRPG Notes</h1>
        {setup && <p className="muted">First run: enter the one-time setup code from the server log and choose a password (at least 10 characters).</p>}
        {setup && (
          <label>
            Setup code
            <input value={code} onChange={(e) => setCode(e.target.value)} autoComplete="one-time-code" required />
          </label>
        )}
        <label>
          {setup ? 'New password' : 'Password'}
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete={setup ? 'new-password' : 'current-password'} required autoFocus />
        </label>
        {err && <p className="error" role="alert">{err}</p>}
        <button className="btn primary" disabled={busy}>
          {setup ? 'Set password' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
